import { tokens, LILAC_200, GREEN_200, GRADIENT_SUCCESS_END, BLACK_500, BLACK_200, BLACK_900, BLACK_700, TRANSPARENT } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getOfferContextualStripWidgetStyles = (props, isSmallScreen) => {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant;
  var borderRadius8 = tokens.borderRadius.BORDER_RADIUS_8;
  var borderWidth = variant === 'default' ? 0 : 1;
  var fontColor = variant === 'disabled' ? BLACK_700 : BLACK_900;
  var borderColor = () => {
    var borderColorMap = {
      default: TRANSPARENT,
      success: GRADIENT_SUCCESS_END,
      disabled: BLACK_500
    };
    return borderColorMap[variant];
  };
  var backgroundColor = () => {
    var backgroundMap = {
      default: LILAC_200,
      success: GREEN_200,
      disabled: BLACK_200
    };
    return backgroundMap[variant];
  };
  return StyleSheet.create({
    gradientContainer: {
      width: '100%',
      padding: tokens.spacing.SPACING_1,
      borderRadius: borderRadius8
    },
    container: {
      backgroundColor: backgroundColor(),
      borderRadius: borderRadius8,
      borderColor: borderColor(),
      borderWidth: borderWidth,
      alignItems: 'center',
      flexDirection: 'row'
    },
    iconTextContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: tokens.spacing.SPACING_8,
      paddingVertical: tokens.spacing.SPACING_10,
      marginRight: tokens.spacing.SPACING_4,
      flex: 1
    },
    icon: {
      width: isSmallScreen ? tokens.spacing.SPACING_20 : tokens.spacing.SPACING_24,
      height: isSmallScreen ? tokens.spacing.SPACING_20 : tokens.spacing.SPACING_24,
      color: fontColor
    },
    textContainer: {
      marginLeft: tokens.spacing.SPACING_4,
      flex: 1
    },
    text: {
      color: fontColor
    },
    offerAppendCta: {
      marginRight: tokens.spacing.SPACING_8,
      alignSelf: 'center'
    }
  });
};